module.exports = __webpack_public_path__ + "static/media/saga.2f97c641.svg";